import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderWidgetModule } from 'app/views/presentations/widgets/header/header.module';
import { SlideshowWidgetModule } from 'app/views/presentations/widgets/slideshow/slideshow.module';
import { VideoWidgetModule } from 'app/views/presentations/widgets/video/video.module';
import { WeatherWidgetModule } from 'app/views/presentations/widgets/weather/weather.module';
import { WidgetButtonComponent } from 'app/views/presentations/widgets/widgetButton.component';
import { WidgetResolver } from 'app/views/presentations/widgets/widgetResolver';
import { WidgetSelectorComponent } from 'app/views/presentations/widgets/widgetSelector.component';

import { SharedModule } from '../../../components/shared.module';
import { EmptyWidgetModule } from './empty/empty.module';
import { NewsWidgetModule } from './news/news.module';
import { UnsupportedWidgetModule } from './unsupported/unsupported.module';
import { WebpageWidgetModule } from './webpage/webpage.module';

@NgModule({
    imports: [
        HttpClientModule,
        SharedModule,
        TranslateModule,
        UnsupportedWidgetModule,
        EmptyWidgetModule,
        BrowserModule,
        HeaderWidgetModule,
        NewsWidgetModule,
        SlideshowWidgetModule,
        WeatherWidgetModule,
        VideoWidgetModule,
        WebpageWidgetModule
    ],
    declarations: [
        WidgetButtonComponent,
        WidgetSelectorComponent
    ],
    exports: [
        WidgetButtonComponent,
        WidgetSelectorComponent
    ]
})
export class WidgetModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: WidgetModule,
            providers: [
                WidgetResolver
            ]
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/widget.module.ts